import { Component, Input } from '@angular/core';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons/faCaretRight';

/** Sidenav component */
@Component({
	selector: 'g-sidenav',
	templateUrl: './sidenav.component.html',
	styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent {
	@Input({ required: true }) categories!: api.CategoryDto[];
	@Input({ required: true }) allCategories!: api.CategoryDto[];
	readonly icons = { faCaretRight, faCaretDown };
}
